import type { TaskLegalMeta } from '../utils/taskLegalStatus';

type TaskLegalBadgeProps = {
	legalMeta: TaskLegalMeta | null;
	copy: (en: string, de: string, hr: string) => string;
	className?: string;
};

export default function TaskLegalBadge({ legalMeta, copy, className = '' }: TaskLegalBadgeProps) {
	if (!legalMeta) return null;

	const isConflict = legalMeta.status === 'date_conflict';
	return (
		<span
			className={`badge ${isConflict ? 'text-bg-warning text-dark' : 'text-bg-secondary'} ${className}`.trim()}
			title={legalMeta.reason}
		>
			{isConflict
				? copy('Seasonal ban warning', 'Saisonales Verbots-Warnsignal', 'Upozorenje na sezonsku zabranu')
				: copy('Needs seasonal check', 'Saisonale Pruefung noetig', 'Potrebna sezonska provjera')}
		</span>
	);
}
